function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_33033_7108)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M29.998 15.8203H26.4238V6.15234C26.4238 2.75994 23.6639 0 20.2715 0H3.57227V15.8203H-0.00195312V22.8516H3.57227V30H26.4238V22.8516H29.998V15.8203ZM24.5776 5.27344H21.1504V1.84623C22.8698 2.19668 24.2271 3.55406 24.5776 5.27344ZM5.33008 1.75781H19.3926V7.03125H24.666V15.8203H5.33008V1.75781ZM24.666 28.2422H5.33008V22.8516H24.666V28.2422ZM28.2402 21.0938H1.75586V17.5781H3.57227V19.3359H5.33008V17.5781H7.08789V19.3359H8.8457V17.5781H10.6035V19.3359H12.3613V17.5781H14.1191V19.3359H15.877V17.5781H17.6348V19.3359H19.3926V17.5781H21.1504V19.3359H22.9082V17.5781H24.666V19.3359H26.4238V17.5781H28.2402V21.0938Z",
  fill: "#23335B"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.08789 5.27344H17.6348V7.03125H7.08789V5.27344Z",
  fill: "#23335B"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.08789 8.78906H22.9082V10.5469H7.08789V8.78906Z",
  fill: "#23335B"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.08789 12.3047H22.9082V14.0625H7.08789V12.3047Z",
  fill: "#23335B"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_33033_7108"
}, /*#__PURE__*/React.createElement("rect", {
  width: 30,
  height: 30,
  fill: "white",
  transform: "translate(-0.00195312)"
})));

var SvgManageProms = function SvgManageProms(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgManageProms, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/manage_proms.94326d71.svg";
export { ForwardRef as ReactComponent };